import middlewares from '@/middlewares/http-common';
import { handleResponse, handleError } from './';

import CommonInterface from '../../interface/data/common.js';
import {
  IRsvpCommon,
  RsvpCommonClass,
} from '../../interface/data/rsvp/common.js';
import { IRsvpLang, RsvpLangClass } from '../../interface/data/rsvp/lang.js';
import GKSCommonInterface from '../../interface/data/gks/common.js';
import GKSLangInterface from '../../interface/data/gks/lang.js';
import {
  ISaveDateCommon,
  SaveDateCommonClass,
} from 'interface/data/saveDate/common';
import { ISaveDateLang, SaveDateLangClass } from 'interface/data/saveDate/lang';
import { EventCommonClass, IEventCommon } from 'interface/data/event/common';
import { EventLangClass, IEventLang } from 'interface/data/event/lang';
import { MailingClass } from 'interface/mailing.js';
import { BingoLangClass, IBingoLang } from 'interface/data/bingo/lang';
import { BingoCommonClass, IBingoCommon } from 'interface/data/bingo/common';

class UserService {
  sentContactMail(
    name: string,
    email: string,
    message: string,
    captcha: string,
  ) {
    const mailingInterface = new MailingClass({
      name: name,
      email: email,
      message: message,
      captcha: captcha,
    });

    return middlewares.httpJson
      .post('/mail/contact', mailingInterface)
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }

  sendCommonData(
    clientId,
    date,
    eventsType,
    defaultType,
    langList,
    isNewSender,
  ) {
    const commonInterface = new CommonInterface({
      clientId: clientId,
      eventDate: date,
      eventsType: eventsType,
      defaultType: defaultType,
      langList: langList,
      isNewSender: isNewSender,
    });

    return middlewares.httpJson
      .post('/client/data/common', commonInterface)
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }

  sendEventCommonData(clientId: string, clientData: Partial<IEventCommon>) {
    const eventInterface = new EventCommonClass({
      ...clientData,
      clientId: clientId,
    });

    return middlewares.httpJson
      .post('/client/data/event', eventInterface)
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }

  sendEventLangData(
    clientId: string,
    clientData: Partial<IEventLang>,
    lang: string,
  ) {
    const eventInterface = new EventLangClass({
      ...clientData,
      clientId: clientId,
    });

    return middlewares.httpJson
      .post('/client/data/event', eventInterface, { params: { lang } })
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }

  sendRsvpCommonData(clientId: string, clientData: Partial<IRsvpCommon>) {
    const rsvpInterface = new RsvpCommonClass({
      ...clientData,
      clientId: clientId,
    });

    return middlewares.httpJson
      .post('/client/data/rsvp', rsvpInterface)
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }

  sendRsvpLangData(
    clientId: string,
    clientData: Partial<IRsvpLang>,
    lang: string,
  ) {
    const rsvpInterface = new RsvpLangClass({
      ...clientData,
      clientId: clientId,
    });

    return middlewares.httpJson
      .post('/client/data/rsvp', rsvpInterface, { params: { lang } })
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }

  sendGKSCommonData(clientId, clientData) {
    const gksInterface = new GKSCommonInterface({
      clientId: clientId,
      version: clientData.version,
      mainColor: clientData.mainColor,
      backgroundColor: clientData.backgroundColor,
      textFont: clientData.textFont,
      hiddenGuests: clientData.hiddenGuests,
    });

    return middlewares.httpJson
      .post('/client/data/gks', gksInterface)
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }

  sendGKSLangData(clientId, _clientData, lang) {
    const gksInterface = new GKSLangInterface({
      clientId: clientId,
    });

    return middlewares.httpJson
      .post('/client/data/gks', gksInterface, { params: { lang } })
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }

  sendBingoCommonData(clientId: string, clientData: Partial<IBingoCommon>) {
    const bingoInterface = new BingoCommonClass({
      ...clientData,
      clientId: clientId,
    });

    return middlewares.httpJson
      .post('/client/data/bingo', bingoInterface)
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }

  sendBingoLangData(
    clientId: string,
    clientData: Partial<IBingoLang>,
    lang: string,
  ) {
    const bingoInterface = new BingoLangClass({
      ...clientData,
      clientId: clientId,
    });

    return middlewares.httpJson
      .post('/client/data/bingo', bingoInterface, { params: { lang } })
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }

  sendSaveDateCommonData(
    clientId: string,
    clientData: Partial<ISaveDateCommon>,
  ) {
    const saveDateData = new SaveDateCommonClass({
      ...clientData,
      clientId: clientId,
    });

    return middlewares.httpJson
      .post('/client/data/save-date', saveDateData)
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }

  sendSaveDateLangData(
    clientId: string,
    clientData: Partial<ISaveDateLang>,
    lang: string,
  ) {
    const saveDateData = new SaveDateLangClass({
      ...clientData,
      clientId: clientId,
    });

    return middlewares.httpJson
      .post('/client/data/save-date', saveDateData, { params: { lang } })
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }
}

export default new UserService();
